module.exports = __webpack_public_path__ + "img/Group 963t3.137dbc26.svg";